import { defineTokens } from "@chakra-ui/react-v3";

export const radii = defineTokens.radii({
  none: { value: "0" },
  "2xs": { value: "1px" },
  xs: { value: "2px" },
  sm: { value: "4px" },
  md: { value: "6px" },
  lg: { value: "8px" },
  xl: { value: "12px" },
  "2xl": { value: "16px" },
  "3xl": { value: "24px" },
  "4xl": { value: "32px" },
  full: { value: "9999px" },
});
